export const transformOptionsByPath = <T extends { id: string; name: string; children?: T[] }>(
  options
): { list: T[]; mapById: Record<string, T> } => {
  const result = { list: [] as T[], mapById: {} as Record<string, T> };

  const addToMapById = item => {
    result.mapById[item.id] = item;
    if (item.children && Array.isArray(item.children)) {
      item.children.forEach(addToMapById);
    }
  };

  (options ?? []).forEach(option => {
    if (!option) return;

    const item = {
      id: option.id,
      name: option.name,
      ...option.extra,
    } as T;

    result.list.push(item);
    addToMapById(item);
  });

  return result;
};
